export enum StatusLinkWithSalesForce {
  LINKEDSF = "Linked SF",
  NOTLINKEDSF = "Not Linked SF",
}
